/**
 * @generated SignedSource<<17e5244b3d06ef2f6b94974b8d13444d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterJewelryType_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuRadioSelectList_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuFilterJewelryType_itemSearch";
};
export type SbSharedRefineMenuFilterJewelryType_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuFilterJewelryType_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterJewelryType_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterJewelryType_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "552b1d61a4b7d66bb2dcb31afc721259";

export default node;
